import { useEffect, useState } from 'react'

function useIsFullscreen(element: React.RefObject<HTMLElement>) {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (!element.current) return

    const onScroll = () => {
      if (!element.current) return
      const rect = element.current.getBoundingClientRect()
      const isVisible = rect.top <= 0 && rect.bottom >= window.innerHeight
      setIsVisible(isVisible)
    }

    window.addEventListener('scroll', onScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [element.current])

  return isVisible
}

export default useIsFullscreen
